<template>
  <q-page class="column justify-center items-center content-center" style="background-color: #000000">
    <AnchorAd/>
    <div class="row col-grow full-width content-center">
      <SiderailAd side="left" />
      <Loading v-if="isLoading" :loading="isLoading"/>
      <template v-else>
        <div class="column items-center" style="flex-grow: 1">
          <LinkPreview class="q-ma-lg" v-if="!!link" :link="link"/>
          <q-btn no-caps label="Create your own link" class="q-my-lg bg-primary" @click="createYourOwnLinkClicked"/>
        </div>
      </template>
      <SiderailAd side="right" />
    </div>
    <InPageAdRepeatable/>
  </q-page>
</template>

<script setup lang="ts">
import LinkPreview from "@/components/LinkPreview/LinkPreview.vue";
import type {Link} from "@/types/link.type";
import {useLinksApi} from "@/components/hooks/api/links.hook";
import {computed} from "vue";
import Loading from "@/components/Loading.vue";
import {SOCIAL_WOLVES_HOME} from "@/utils/contants";
import {sanitizeHTML} from "@/utils/sanitize";
import AnchorAd from "@/ads/AnchorAd.vue";
import InPageAdRepeatable from "@/ads/InPageAdRepeatable.vue";
import SiderailAd from "@/ads/SiderailAd.vue"

export interface LinkDisplayViewProps {
  guid: string
}

const props = defineProps<LinkDisplayViewProps>()

const linksApi = useLinksApi()
const {data, isLoading, error} = linksApi.getLinkByGuid(props.guid, undefined)

const link = computed<Link>(() => {
  if (data?.value?.link) {
    const oldTitle = data?.value?.link.title
    document.title = `${sanitizeHTML(oldTitle)} | SocialWolvez.com`
  }
  return data?.value?.link;
})

function createYourOwnLinkClicked() {
  window.open(SOCIAL_WOLVES_HOME)
}
</script>

<style scoped></style>
